import React from 'react';
import { useGoogleTranslator } from '@/hooks/useGoogleTranslator';
import { TextField, TextFieldProps } from '@mui/material';
import styles from './TextInput.styles';

export const TextInput = React.forwardRef<HTMLInputElement, TextFieldProps>(
  ({ variant = 'standard', label, ...rest }, ref) => {
    const labelTranslated = useGoogleTranslator((label || '').toString());

    return (
      <TextField
        variant={variant}
        fullWidth
        label={labelTranslated}
        className={styles.textfield}
        inputRef={ref}
        {...rest}
      />
    );
  }
);

TextInput.displayName = 'TextInput';
